const actions = {
  SET_STATE: 'galleryListing/SET_STATE',
  CREATE_MAIN_GALLERY: 'galleryListing/CREATE_MAIN_GALLERY',
  GET_MAIN_GALLERY_LIST: 'galleryListing/GET_MAIN_GALLERY_LIST',
  REMOVE_MAIN_GALLERY: 'galleryListing/REMOVE_MAIN_GALLERY',
}

export default actions
